import type {TicketingDetailsData} from './types';

import {dateToReadableDate} from '@date-picker';
import {Badge, Chip} from '@ds/components';
import {getStatusChipProps} from 'common/status-chip/getStatusChipProps';
import {TicketState} from 'utils/constant';

type TicketingInfoProps = {
  data: TicketingDetailsData;
};

const TicketingInfo: React.FC<TicketingInfoProps> = ({data}) => {
  const chipProps = getStatusChipProps(data.state);

  return (
    <dl className="px-4">
      <div className="flex min-h-12 items-center justify-between gap-4 border-b border-gray-03 py-2">
        <dt className="text-body-sm text-gray-07">وضعیت</dt>
        <dd>
          {data.state ? (
            <Chip
              label={TicketState[data.state as keyof typeof TicketState] ?? data.state}
              variant={chipProps.variant}
              color={chipProps.color}
              size="sm"
              interactive={false}
            />
          ) : (
            <span className="text-body-sm text-gray-07">—</span>
          )}
        </dd>
      </div>

      <div className="flex min-h-12 items-center justify-between gap-4 border-b border-gray-03 py-2">
        <dt className="text-body-sm text-gray-07">موضوع</dt>
        <dd className="text-body-sm-emphasis text-neutral-fg">{data.tag_title || '—'}</dd>
      </div>

      {data.order_code ? (
        <div className="flex min-h-12 items-center justify-between gap-4 border-b border-gray-03 py-2">
          <dt className="text-body-sm text-gray-07">کد سفارش</dt>
          <dd>
            <Badge color="primary" size="md">
              {data.order_code}
            </Badge>
          </dd>
        </div>
      ) : null}

      <div className="flex min-h-12 items-center justify-between gap-4 py-2">
        <dt className="text-body-sm text-gray-07">روز</dt>
        <dd className="text-body-sm text-neutral-fg">
          {data.created_at
            ? dateToReadableDate({
                date: data.created_at,
                day: true,
                month: true,
                year: true
              })
            : '—'}
        </dd>
      </div>
    </dl>
  );
};

export default TicketingInfo;
